import { MessageCircle, BarChart3, CheckCircle, Settings } from 'lucide-react';

const ProcessSteps = () => {
  const steps = [
    {
      icon: MessageCircle,
      title: 'Wensen',
      description: 'In een persoonlijk adviesgesprek gaan we in op jouw wensen, eisen, risico\'s en persoonlijke situatie. Ook vertellen wij wat je van ons kan verwachten en hoe onze dienstverlening eruit ziet.'
    },
    {
      icon: BarChart3,
      title: 'Advies',
      description: 'Na een zorgvuldige analyse zoeken wij het beste aanbod voor jouw situatie. Dit kunnen allerlei mogelijkheden zijn. We bespreken ze uitgebreid met je om een goed advies te geven.'
    },
    {
      icon: CheckCircle,
      title: 'Beslissing',
      description: 'Neem de tijd voor een weloverwogen beslissing. Heb je na het adviesgesprek nog vragen, neem dan vooral even contact met ons op. Als je akkoord gaat met ons voorstel, zullen we de verzekeringen afsluiten.'
    },
    {
      icon: Settings,
      title: 'Service',
      description: 'Eenmaal klant, altijd ondersteuning. We staan voor je klaar bij schades en wijzigingen in jouw situatie. Ook zorgen we voor een regelmatige evaluatie van je verzekeringspakket.'
    }
  ];

  return (
    <section id="proces" className="py-20 bg-gradient-subtle scroll-mt-24" aria-labelledby="process-heading">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 id="process-heading" className="text-4xl font-bold text-secondary mb-4">
            Hoe wij werken
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Ons bewezen proces zorgt ervoor dat je de juiste verzekeringen krijgt voor jouw specifieke situatie
          </p>
        </div>

        <ol className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" role="list">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <li key={index} className="relative" role="listitem">
                {/* Connection line */}
                {index < steps.length - 1 && (
                  <div 
                    className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-primary/20 z-0" 
                    aria-hidden="true"
                  ></div>
                )}
                
                <div className="bg-card rounded-lg p-6 shadow-card hover:shadow-primary transition-all duration-300 relative z-10 h-full">
                  <div 
                    className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mb-4 mx-auto"
                    aria-hidden="true"
                  >
                    <Icon className="w-8 h-8 text-primary-foreground" />
                  </div>
                  
                  <h3 className="text-xl font-bold text-secondary text-center mb-4">
                    Stap {index + 1}: {step.title}
                  </h3>
                  
                  <p className="text-muted-foreground text-center leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
};

export default ProcessSteps;